import { render, staticRenderFns } from "./ValorKm.vue?vue&type=template&id=8603d862"
import script from "./ValorKm.vue?vue&type=script&lang=js"
export * from "./ValorKm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports